import { useQuery } from "@tanstack/react-query";

import { integrationsApi } from "../api/integrations.api";

import type { ConfigurationContext } from "@/types/configuration";

export type SchemaSource = { type: "module"; integrationName: string; moduleName: string };

export const uiSchemaKeys = {
  all: ["uiSchema"] as const,
  schema: (source: SchemaSource, context: ConfigurationContext) =>
    [...uiSchemaKeys.all, source, context] as const,
};

export function useUiSchema(
  source: SchemaSource,
  context: ConfigurationContext,
  enabled = true,
) {
  return useQuery({
    queryKey: uiSchemaKeys.schema(source, context),
    queryFn: () =>
      integrationsApi.fetchModuleConfigurationSchema(
        source.integrationName,
        source.moduleName,
        context,
      ),
    staleTime: 20 * 60 * 1000,
    enabled,
  });
}
